import { z } from "zod";
import { BaseOutputSchema } from "../BaseOutput";
import { ReportExecuteDtoSchema } from "./ReportExecuteDto";

export const GetDataForReportRunOutputSchema = BaseOutputSchema.extend({
    reportToRun: ReportExecuteDtoSchema,
});

export type GetDataForReportRunOutput = z.infer<typeof GetDataForReportRunOutputSchema>;